import * as t from "io-ts";

import fetchApi from "ui-io/fetch-api";
import { TaskInfoT } from "../../task-io";

type EditRequestT = {
  payload: {
    info?: TaskInfoT;
    priority?: number;
    isFastlaneTask?: boolean;
		companyDetail?: object;
		configuration?: object;
  };
  taskId: string;
};

const TaskEditResultIO = t.type({
  task_id: t.string,
});

export const taskEditMutation = (editRequest: EditRequestT) => {
  const { payload, taskId } = editRequest;

  return fetchApi({
    service: "admin-service",
    method: "POST",
    body: payload,
    pathname: `/edit-tasks/${taskId}`,
    key: `task-edit-${taskId}`,
    codec: TaskEditResultIO,
  });
};
